import { useMemo, useEffect } from "react";
import { ReactComponent as LeftIcon } from "../../assets/icons/left-icon.svg";
import { ReactComponent as RightIcon } from "../../assets/icons/current-icon.svg";
import { ReactComponent as BellIcon } from "../../assets/icons/bell-icon.svg";
import { ReactComponent as LogoutIcon } from "../../assets/icons/logout-icon2.svg";
import { ReactComponent as LogoutIconTwo } from "../../assets/icons/logout-iconTwo.svg";
import { ReactComponent as UserIcon } from "../../assets/icons/user-iconTwo.svg";
import { ReactComponent as SearchIcon } from "../../assets/icons/search-icon.svg";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate, NavLink } from "react-router-dom";
import { useAuthContext } from "../../contexts/AuthContext";
import { ReactComponent as DownArrow } from "../../assets/icons/down-arrow.svg";
import { ReactComponent as MenuIcon } from "../../assets/icons/menu-iconn.svg";
import { useState } from "react";
import { compareAsc, format } from "date-fns";

import "./userDetailsNav.css";
import { api } from "../..";
import { useDispatch, useSelector } from "react-redux";
import { storeSearchedBabies } from "../../redux/babies/babiesActions";

const UserDetailsNav = ({
  pathname,
  superAdminSideBarLinks,
  adminSideBarLinks,
  facilityHealthWorkerSideBarLinks,
  parentSideBarLinks,
  imWorkerSideBarLinks,
}) => {
  const [showMobileNav, setShowMobileNav] = useState(false);
  const [openDropdown, setOpenDropDown] = useState(false);
  const [childId, setChildId] = useState("");
  const [searchText, setSearchText] = useState("");
  const [upComingVacs, setUpcomingVacs] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [children, setChildren] = useState();
  // const [facility, setFacility] = useState(false);
  const [userData, setUserData] = useState();

  const [offlineUserData, setOfflineUserData] = useState();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  // const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userDetails = useSelector((state) => state.currentUser.currentUser);
  // const facility = JSON.parse(localStorage.getItem("offlineFacilityData"));

  let sideBarLinks;

  useEffect(() => {
    // getUserData();
    // getUserFacility();
    // setUpcomingVacs(alarm);
    // upComingVacAlert();
  }, []);

  //////  Upcoming Vac Alerts Logic

  const todayDate = new Date();

  const todayDateIncreamentedByFive = todayDate.setDate(
    todayDate.getDate() + 5
  );

  const todayDateFormated = format(todayDateIncreamentedByFive, "yyyy-MM-dd");
  const birthDay = "2022-09-02";

  if (todayDateFormated > birthDay) {
  } else {
  }

  if (localStorage.getItem("user_type_id") === "2") {
    sideBarLinks = adminSideBarLinks;
  } else if (localStorage.getItem("user_type_id") === "1") {
    sideBarLinks = superAdminSideBarLinks;
  } else if (localStorage.getItem("user_type_id") === "3") {
    sideBarLinks = facilityHealthWorkerSideBarLinks;
  } else if (localStorage.getItem("user_type_id") === "4") {
    sideBarLinks = imWorkerSideBarLinks;
  } else {
    sideBarLinks = parentSideBarLinks;
  }

  const searchChild = () => {
    api
      .get(`/api/search_child`, { params: { data: searchText } })
      .then((res) => {
        // setChildId(res.data.data?.id);
        setChildren(res.data.data);
        dispatch(storeSearchedBabies(res.data?.data));

        toast.success("Searched Successfully!");
      })
      .catch((error) => {
        toast.error("Cannot find child, please try again");
      });
  };

  useEffect(() => {
    if (children) {
      navigate(`/panel/searched-babies`);
    }
  }, [children]);

  let pathTitle = "";

  switch (pathname) {
    case "/panel/admin-dashboard":
      pathTitle = "Admin";
      break;
    case "/panel/personnel-dashboard":
      pathTitle = "Healthcare Personnel";
      break;
    case "/panel/parent-dashboard":
      pathTitle = "Parent";
      break;
    case "/panel/child-details":
      pathTitle = "Child's Details";
      break;
    case "/panel/add-child":
      pathTitle = "Add Child";
      break;
    case "/panel/profile":
      pathTitle = "Profile";
      break;

    default:
      pathTitle = "";
  }

  const toggleMobileMenu = () => {
    setShowMobileNav(!showMobileNav);
  };

  // For getting username acronym

  const str = `${userDetails?.first_name} ${userDetails?.last_name}`;
  const matches = str.match(/\b(\w)/g);
  const acronym = matches.join("");

  let id = 30;

  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <div className="userDetails__Bar--container">
      {showMobileNav ? <div className="mobile__menu-backdrop"></div> : null}
      <span className="userDetails__content--container">
        {/* <span className="mobile__back--nav" onClick={() => navigate(-1)}>
          <LeftIcon />
          <p style={{ marginLeft: "1rem" }}>Back</p>
        </span> */}

        <span className="currentLink-and-title ">
          <div className="search__input-and-icon">
            <input
              type="text"
              placeholder="Enter parent's phone no"
              value={searchText}
              className="search__bar"
              onChange={(e) => setSearchText(e.target.value)}
            />
            {/* <SearchIcon className="search__icon" /> */}
            <button className="search__CTA" onClick={() => searchChild()}>
              Search
            </button>
          </div>
          {/* <span className="series__and__details">
            <p
              className="current__link"
              onClick={() => navigate(-1)}
              style={{ cursor: "pointer" }}
            >
              Series
            </p>
            <p className="current__link current__series">
              <RightIcon style={{ margin: "0 2rem" }} />
            </p>
          </span> */}
          {/* <p className="page__heading">{pathTitle}</p> */}
        </span>
        <span className="notification-and-userName">
          <span
            className="notification-icon-and-number"
            onClick={() =>
              // console.log({ showNotifications });
              setShowNotifications(!showNotifications)
            }
            style={{ cursor: "pointer" }}
          >
            <MenuIcon className="show__menu--CTA" onClick={toggleMobileMenu} />
            {/* <BellIcon className="hide-notification" /> */}
            {/* <p className="notification__number hide-notification">
              {upComingVacs?.length}
            </p> */}
            {showNotifications ? (
              <div className="notification__content-container">
                <p className="vac__notification-heading">
                  You have {upComingVacs.length} Children with pending/due
                  vaccinations
                </p>
                {upComingVacs.map((vac, index) => {
                  if (vac[0].status === "pending") {
                    return (
                      <div
                        className="notification__span"
                        onClick={() =>
                          navigate(`/panel/child-details/${vac[0].child_id}`)
                        }
                      >
                        {index + 1}. Date - {vac[0].date.substr(0, 10)} - Click
                        to view child
                      </div>
                    );
                  }
                })}
              </div>
            ) : null}
          </span>

          <span
            className={
              pathname === "/company-panel/profile"
                ? "hide"
                : "username-and-arrow"
            }
          >
            <p className="username__abbr hide__abbr">{acronym}</p>
            <MenuIcon
              style={{ height: "3rem", fill: "rgb(26 115 232)" }}
              className="hide__mobile-menu--icon"
              onClick={() => toggleMobileMenu()}
            />

            {userDetails?.user_type === "admin" ? (
              <span className="user__name-and-user__type">
                <p className="username hide__name">
                  {userDetails?.first_name} {userDetails?.last_name}
                </p>
                <p
                  className="user__type hide__name"
                  style={{ color: "#989898", fontSize: ".9rem" }}
                >
                  Admin
                </p>
              </span>
            ) : (
              <p className="username">
                {userDetails?.first_name} {userDetails?.last_name}
              </p>
            )}
            <DownArrow
              className={
                openDropdown
                  ? "downarrow__in__detailsBar--flipped hide__abbr"
                  : "downarrow__in__detailsBar hide__abbr"
              }
              onClick={() => setOpenDropDown(!openDropdown)}
            />
            {openDropdown ? (
              <span className="logout-and-profile__link-CTAs">
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    borderBottom: "0.5px solid #F2F5F9",
                    paddingBottom: "2rem",
                  }}
                  onClick={() => {
                    logout();
                  }}
                >
                  <LogoutIconTwo />{" "}
                  <p className="dropdown__prompts--text"> Log Out</p>
                </span>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    paddingTop: "2rem",
                  }}
                  onClick={() => {
                    navigate("/panel/profile");
                  }}
                >
                  <UserIcon />{" "}
                  <p className="dropdown__prompts--text">My Profile</p>
                </span>
              </span>
            ) : null}
          </span>
          {pathname === "/company-panel/profile" ? (
            <span
              className="logout__CTA-and-text"
              onClick={() => {
                logout();
              }}
            >
              <LogoutIcon />
              <p className="logout__text">Log out</p>
            </span>
          ) : (
            ""
          )}
          {/* <span
            className="logout__CTA-and-text"
            onClick={() => {
              localStorage.clear();
              setAuthDetails("");
            }}
          >
            <LogoutIcon />
            <p className="logout__text">Log out</p>
          </span> */}
        </span>
      </span>
      {showMobileNav ? (
        <div className={showMobileNav ? "mobile__menu" : "hide__mobile-menu"}>
          <img
            src={require("../../assets/images/imtrackerlogo.png")}
            alt="imtracker__logo"
            className="login__imt--logo"
          />
          <span className="mobile__user--data">
            <p
              className="username__abbr"
              style={{ height: "4rem", width: "4rem" }}
            >
              {acronym}
            </p>
            {userDetails?.user_type === "admin" ? (
              <span className="user__name-and-user__type">
                <p className="username">
                  {userDetails?.first_name} {userDetails?.last_name}
                </p>
                <p
                  className="user__type "
                  style={{ color: "#989898", fontSize: ".9rem" }}
                >
                  Admin
                </p>
              </span>
            ) : (
              <p className="username mobile__username">
                {userDetails?.first_name} {userDetails?.last_name}
              </p>
            )}
          </span>
          <ul className="side__nav--links">
            {sideBarLinks.map((link) => {
              return (
                <NavLink
                  to={`${link.urlLink}`}
                  className={({ isActive }) =>
                    isActive ? "active" : "link__and__icon"
                  }
                  key={id++}
                >
                  {link.urlIcon} <li className="link">{link.urlName}</li>
                </NavLink>
              );
            })}
          </ul>

          <Link to="/">
            <span
              className="link__and__icon logout__CTA"
              onClick={() => localStorage.clear()}
            >
              <LogoutIcon />
              <p className="link ">Log out</p>
            </span>
          </Link>
        </div>
      ) : null}
    </div>
  );
};

export default UserDetailsNav;
